module.exports = __webpack_public_path__ + "uPQDIod2JOJYdqZ-K/agent-training-center_about_our_leads.png";